import React, { startTransition, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotFoundContainer } from '@neurowyzr/nw-dragonfly-lib';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllowedCountries, getAllowedLanguages, getCountrySpecificDetails, setThemePrefixBasedOnCountry } from '../apis/utils/user/login';
import { getCountryAndLanguageCode, replaceCountryAndLanguageCode } from '../apis/utils';
import { CountryLanguageObj } from '../apis/user';
import { ROUTES } from '../constants';

function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();  
  
  const location = useLocation();
  
  const countryLanguageObj: CountryLanguageObj = getCountryAndLanguageCode(location);
  const countrySpecificDetails = getCountrySpecificDetails(countryLanguageObj, 'all');

  const [isBtnVisible, setIsBtnVisible] = useState(false);

  useEffect(()=>{
    if(getAllowedCountries(countrySpecificDetails).includes(countryLanguageObj.countryCode) && getAllowedLanguages(countrySpecificDetails).includes(countryLanguageObj.languageCode)){
      setIsBtnVisible(true);
    }else if(getAllowedCountries(countrySpecificDetails).includes(countryLanguageObj.countryCode) && !getAllowedLanguages(countrySpecificDetails).includes(countryLanguageObj.languageCode)){
      setIsBtnVisible(true);
    }
  },[countryLanguageObj, countrySpecificDetails])
  
  const handleGoTo = () => {

    startTransition(() => {
      if(getAllowedCountries(countrySpecificDetails).includes(countryLanguageObj.countryCode) && getAllowedLanguages(countrySpecificDetails).includes(countryLanguageObj.languageCode)){
        navigate(replaceCountryAndLanguageCode(ROUTES.DASHBOARD, countryLanguageObj));
      }else if(getAllowedCountries(countrySpecificDetails).includes(countryLanguageObj.countryCode) && !getAllowedLanguages(countrySpecificDetails).includes(countryLanguageObj.languageCode)){
        const tempCountryLanguageObj = countryLanguageObj;
        tempCountryLanguageObj.languageCode = 'en';
        navigate(replaceCountryAndLanguageCode(ROUTES.DASHBOARD, countryLanguageObj));
      }
    });
  }

  return (
    <div data-testid='notfound-wrapper' className='h-full w-full'>
      <NotFoundContainer
        themePrefix={setThemePrefixBasedOnCountry()}
        languageContent={{
          title: t(`not_found_${isBtnVisible ? '': 'invalid_'}title`),
          desc: t(`not_found_${isBtnVisible ? '': 'invalid_'}desc`),
          btnLbl: t('not_found_btnLbl'),
        }}
        isBtnVisible={isBtnVisible}
        handleGoTo={handleGoTo}
      />
    </div>
  );
}

export default NotFound;
